import {StageForm} from "./form";

const CreateStage = () => {
   return <StageForm  />;
};

export default CreateStage;
